import {MODALS} from 'common/domain/constants';
import {STATES} from 'common/domain/states';

class TeamCalendarListCardController {

  constructor(inceptionService) {

    'ngInject';
    this.inceptionService = inceptionService;
    this.open = false;
  }

  $onInit(){
    this.urlDestination = STATES.VACATIONS_ABSENCES.DELEGATE;
  }

  toggle() {
    this.open = !this.open;
  }

  get modalWarningDelegation() {
    const $modal = $(MODALS.WARNING_DELEGATION_MODAL);
    return $modal;
  }

  _showModalWarningDelegation() {
    this.modalWarningDelegation.modal('show');
  }

  incept(employee) {
    if (this.hasDelegated) {
      return this._showModalWarningDelegation();
    }
    this.inceptionService.incept(employee.employeeId, 'team-calendar-mobile');
  }

}

export default TeamCalendarListCardController;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamCalendarMobile/teamCalendarList/teamCalendarListCard/teamCalendarListCard.controller.js